/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadWarningDetails } from './LeadWarningDetails';
import {
    LeadWarningDetailsFromJSON,
    LeadWarningDetailsFromJSONTyped,
    LeadWarningDetailsToJSON,
    LeadWarningDetailsToJSONTyped,
} from './LeadWarningDetails';

/**
 * 
 * @export
 * @interface LeadWarning
 */
export interface LeadWarning {
    /**
     * 
     */
    type: LeadWarningTypeEnum;
    /**
     * 
     */
    details?: LeadWarningDetails;
}


/**
 * @export
 */
export const LeadWarningTypeEnum = {
    PackageLimitExceeded: 'PACKAGE_LIMIT_EXCEEDED',
} as const;
export type LeadWarningTypeEnum = typeof LeadWarningTypeEnum[keyof typeof LeadWarningTypeEnum];


/**
 * Check if a given object implements the LeadWarning interface.
 */
export function instanceOfLeadWarning(value: object): value is LeadWarning {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'PACKAGE_LIMIT_EXCEEDED') return false;
    
    return true;
}

export function LeadWarningFromJSON(json: any): LeadWarning {
    return LeadWarningFromJSONTyped(json, false);
}

export function LeadWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWarning {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'details': json['details'] == null ? undefined : LeadWarningDetailsFromJSON(json['details']),
    };
}

export function LeadWarningToJSON(json: any): LeadWarning {
    return LeadWarningToJSONTyped(json, false);
}

export function LeadWarningToJSONTyped(value?: LeadWarning | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'details': LeadWarningDetailsToJSON(value['details']),
    };
}

